<div class="card">
  <p-megamenu [model]="tabs()" [style]="{ 'border-radius': '3rem', display: 'flex' }" styleClass="p-4 bg-surface-0 dark:bg-surface-900">
      <ng-template #start>
          <img src="https://www.nrg.gr/themes/custom/nrg/media/logo2021-vertical.svg" width="35" alt="">
      </ng-template>
      <ng-template #item let-item >
          <a *ngIf="item.root" pRipple class="flex items-center cursor-pointer px-4 py-2 overflow-hidden relative font-semibold text-lg uppercase" style="border-radius: 2rem" [routerLink]="item.routerLink" >
              <i [ngClass]="item.icon"></i>
              <span class="ml-2">{{ item.label }}</span>
          </a>
          <a *ngIf="!item.root && !item.image" class="flex items-center p-4 cursor-pointer mb-2 gap-2 w-full" [routerLink]="item.routerLink">
              <span class="inline-flex items-center justify-center rounded-full bg-primary text-primary-contrast w-12 h-12">
                  <i [ngClass]="item.icon + ' text-lg'"></i>
              </span>
              <span class="inline-flex flex-col gap-1">
                  <span class="font-medium text-lg text-surface-900">{{ item.label }}</span>
                  <span class="whitespace-nowrap">{{ item.subtext }}</span>
              </span>
          </a>
          <div *ngIf="item.image" class="flex flex-col items-start gap-4">
              <img [src]="item.image" alt="megamenu-demo" class="w-full" />
              <span>{{ item.subtext }}</span>
              <p-button [label]="item.label" [outlined]="true"></p-button>
          </div>
      </ng-template>
      <ng-template #end>
        @if (_profilePictureUrl$ | async; as profilePictureUrl) {
          <!-- <p-speeddial [model]="items" direction="down" [style]="{ position: 'absolute', right: 0, bottom: 0 }" [buttonProps]="{ severity: 'help', rounded: true }" [tooltipOptions]="{ tooltipPosition: 'left' }" /> -->
          <img class="app-menu__profile-picture" [src]="profilePictureUrl" alt="Profile Picture" (click)="showDialog()" >
          <p-avatar [image]="profilePictureUrl" shape="circle" class="cursor-pointer" />
         
          }@else {
            <div class="app-menu__profile-picture cursor-pointer" (click)="showDialog()">{{_accountInitials$ | async}}</div>
          }
          <p-dialog class="flex justify-center items-center" header="Profile" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
            <p-button (click)="logout()" label="Sign Out" />
        </p-dialog>

      </ng-template>
  </p-megamenu>
</div>
